import React, { useState, useEffect } from 'react';
import './App.css';
import logo2025 from './img/ServiCareLogo.jpg';
import carHoists from './img/CarHoists.jpeg';
import manWorkingOnCar from './img/ManWorkingOnCar.webp';
import serviceBays from './img/ServiceBays.webp';
import ServiLogo2025 from './img/ServiLogo2025.png';


function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Close mobile menu when resizing to desktop width
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 900) setIsMenuOpen(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    let favicon = document.querySelector("link[rel='icon']");
    if (!favicon) {
      favicon = document.createElement('link');
      favicon.setAttribute('rel', 'icon');
      document.head.appendChild(favicon);
    }
    favicon.setAttribute('href', logo2025);
  }, []);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);

  const handleQuoteSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);

    const fullName = formData.get('fullName') || '';
    const mobile = formData.get('mobile') || '';
    const email = formData.get('email') || '';
    const vehicle = formData.get('vehicle') || '';
    const serviceType = formData.get('serviceType') || '';
    const message = formData.get('message') || '';

    const lines = [
      `Full name: ${fullName}`,
      `Mobile number: ${mobile}`,
      `Email address: ${email}`,
      `Vehicle make & model: ${vehicle}`,
      `Service or enquiry type: ${serviceType}`,
      '',
      'What do you need a quote for?',
      message,
    ];

    const body = encodeURIComponent(lines.join('\n'));
    const subject = encodeURIComponent('ServiCare Auto Center - Service / Maintenance quote request (Test)');

    window.location.href = `mailto:info@servicare.co.za?subject=${subject}&body=${body}`;
  };

  return (
    <div className="app">
      <header className="top-bar">
        <div className="container top-bar__inner">
          <div className="top-bar__brand">
            <div className="logo-mark">
              <img src={logo2025} alt="ServiCare Auto Center logo" className="logo-mark__img" />
            </div>
            <div className="top-bar__brand-text">
              <span className="brand-name">ServiCare Auto Center</span>
              <span className="brand-sub">Service &amp; Maintenance Network</span>
            </div>
          </div>

          <button
            className="mobile-menu-btn"
            onClick={toggleMenu}
            aria-label="Toggle navigation"
            aria-expanded={isMenuOpen}
          >
            {isMenuOpen ? '✕' : '☰'}
          </button>

          <nav className={`top-bar__nav ${isMenuOpen ? 'top-bar__nav--open' : ''}`}>
            <a href="#services" onClick={closeMenu}>
              Services
            </a>
            <a href="#plans" onClick={closeMenu}>
              Maintenance Plans
            </a>
            <a href="#quote" onClick={closeMenu}>
              Get a Quote
            </a>
            <a href="#network" onClick={closeMenu}>
              Nationwide Network
            </a>
            <a href="#trust" onClick={closeMenu}>
              Why ServiCare
            </a>
            <a href="#contact" onClick={closeMenu}>
              Contact
            </a>
          </nav>
        </div>
      </header>

      <main>
        <section className="hero" id="top">
          <div className="hero-overlay" />
          <div className="hero-content">
            <div className="hero-text">
              <p className="eyebrow">Nationwide Vehicle Service &amp; Maintenance Solutions</p>
              <h1>ServiCare Auto Center</h1>
              <p className="hero-subtext">
                Professional vehicle servicing. RMI-aligned workshops. Minor &amp; Major Services. Nationwide
                Network. Exclusive Member Discounts.
              </p>
              <div className="hero-ctas">
                <a href="#quote" className="btn btn-primary">
                  Get a Quote
                </a>
                <a href="#plans" className="btn btn-outline">
                  View Service Plans
                </a>
                <a href="#network" className="btn btn-ghost">
                  Find a Workshop
                </a>
              </div>
              <div className="hero-badges">
                <span>RMI-aligned suppliers</span>
                <span>Nationwide network</span>
                <span>Up to 20% member discounts</span>
              </div>
            </div>
            <div className="hero-panel">
              <div className="hero-panel-inner">
                <div className="panel-header">
                  <span className="panel-label">Structured Service Network</span>
                  <h2>Not just another workshop.</h2>
                  <p>
                    ServiCare Auto Center is a hybrid between a service center, a network provider and a
                    maintenance plan administrator.
                  </p>
                </div>
                <div className="panel-grid">
                  <div className="panel-item">
                    <span className="panel-eyebrow">Centralised</span>
                    <strong>Call centre bookings</strong>
                  </div>
                  <div className="panel-item">
                    <span className="panel-eyebrow">Network</span>
                    <strong>Vetted, compliant workshops</strong>
                  </div>
                  <div className="panel-item">
                    <span className="panel-eyebrow">Protection</span>
                    <strong>Cost-controlled plans</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="section about" id="about">
          <div className="section-inner">
            <div className="section-header">
              <p className="eyebrow">About ServiCare</p>
              <h2>Who we are.</h2>
              <p>
                ServiCare Auto Center is a nationwide vehicle service and maintenance solution designed to
                make car servicing simple, affordable and professional.
              </p>
            </div>
            <div className="about-grid">
              <div className="about-card">
                <h3>What we do</h3>
                <p>
                  Founded as part of a structured call center operation, ServiCare connects vehicle owners to
                  trusted, compliant service centers while offering structured maintenance plans and
                  discounted service solutions.
                </p>
                <ul>
                  <li>Professional workshop standards</li>
                  <li>Nationwide coverage</li>
                  <li>Partnered RMI-aligned service centers</li>
                  <li>Centralized customer support</li>
                </ul>
              </div>
              <div className="about-card about-highlight">
                <h3>Positioned above a normal workshop</h3>
                <p>
                  ServiCare Auto Center is not just a workshop — it is a structured vehicle service network
                  providing centralized support, nationwide access, and cost-controlled maintenance
                  solutions for everyday motorists.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="section visuals">
          <div className="section-inner">
            <div className="section-header">
              <p className="eyebrow">Workshop Environment</p>
              <h2>Where your vehicle is cared for.</h2>
              <p>Modern, clean service bays with professional technicians and diagnostic equipment.</p>
            </div>
            <div className="workshop-gallery">
              <div className="workshop-card workshop-card-hoist">
                <img
                  src={carHoists}
                  alt="Vehicle on a hoist in a professional workshop"
                  className="workshop-image"
                />
              </div>
              <div className="workshop-card workshop-card-mechanic">
                <img
                  src={manWorkingOnCar}
                  alt="Mechanic working on a car in a clean workshop"
                  className="workshop-image"
                />
              </div>
              <div className="workshop-card workshop-card-bay">
                <img
                  src={serviceBays}
                  alt="Modern, clean vehicle service bay"
                  className="workshop-image"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="section services" id="services">
          <div className="section-inner">
            <div className="section-header">
              <p className="eyebrow">Our Services</p>
              <h2>What we offer.</h2>
              <p>We provide structured vehicle service and maintenance solutions for motorists.</p>
            </div>
            <div className="services-list">
              <div className="services-column">
                <ul>
                  <li>Minor services</li>
                  <li>Major services</li>
                  <li>Brake services</li>
                  <li>Suspension repairs</li>
                  <li>Diagnostics</li>
                </ul>
              </div>
              <div className="services-column">
                <ul>
                  <li>Engine repairs</li>
                  <li>Clutch replacement</li>
                  <li>76-point safety inspections</li>
                  <li>Preventative maintenance plans</li>
                </ul>
              </div>
            </div>
            <div className="parts-note">
              <h3>Parts &amp; quality you can trust</h3>
              <p>
                All parts used are sourced from RMI-aligned suppliers, approved aftermarket parts, or
                OEM/Agent parts where required.
              </p>
            </div>
          </div>
        </section>

        <section className="section plans" id="plans">
          <div className="section-inner">
            <div className="section-header">
              <p className="eyebrow">ServiCare Maintenance Plans</p>
              <h2>Service &amp; maintenance plans.</h2>
              <p>We offer structured maintenance plans designed to reduce the cost of vehicle ownership.</p>
            </div>

            <div className="plan-benefits">
              <h3>Members receive:</h3>
              <div className="benefits-grid">
                <span>Up to 20% discount on services</span>
                <span>Priority booking</span>
                <span>Nationwide servicing support</span>
                <span>Access to compliant workshops</span>
                <span>Centralized call center support</span>
                <span>Service history record assistance</span>
              </div>
            </div>

            <p className="plans-footnote">
              If your vehicle is outside KwaZulu-Natal, we facilitate your booking at an approved partner
              workshop.
            </p>
          </div>
        </section>

        <section className="section quote" id="quote">
          <div className="section-inner">
            <div className="quote-grid">
              <div className="quote-copy">
                <p className="eyebrow">Get a quote</p>
                <h2>Request a service or maintenance quote.</h2>
                <p>
                  Tell us which services you need and we&apos;ll prepare a quote using our structured maintenance
                  plans and vetted ServiCare workshop network.
                </p>
                <ul className="quote-points">
                  <li>Minor &amp; major services, brakes, suspension and more</li>
                  <li>ServiCare Maintenance Plans to help reduce ownership costs</li>
                  <li>Access to compliant, vetted workshops nationwide</li>
                </ul>
              </div>

              <form className="quote-form" onSubmit={handleQuoteSubmit}>
                <div className="quote-form-header">
                  <h3>Request a service</h3>
                  <p>Share a few details and we&apos;ll contact you with a service or maintenance quote.</p>
                </div>
                <div className="form-row two-column">
                  <div className="form-field">
                    <label htmlFor="quote-name">Full name</label>
                    <input id="quote-name" name="fullName" type="text" placeholder="e.g. John Dlamini" />
                  </div>
                  <div className="form-field">
                    <label htmlFor="quote-mobile">Mobile number</label>
                    <input id="quote-mobile" name="mobile" type="tel" placeholder="e.g. +27 82 000 0000" />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-field">
                    <label htmlFor="quote-email">Email address</label>
                    <input id="quote-email" name="email" type="email" placeholder="e.g. you@example.co.za" />
                  </div>
                </div>
                <div className="form-row two-column">
                  <div className="form-field">
                    <label htmlFor="quote-vehicle">Vehicle make &amp; model</label>
                    <input id="quote-vehicle" name="vehicle" type="text" placeholder="e.g. VW Polo 1.4 TSI" />
                  </div>
                  <div className="form-field">
                    <label htmlFor="quote-service-type">Service or enquiry type</label>
                    <select id="quote-service-type" name="serviceType" defaultValue="">
                      <option value="" disabled>
                        Select one
                      </option>
                      <option value="minor-service">Minor service</option>
                      <option value="major-service">Major service</option>
                      <option value="diagnostics">Diagnostics / warning lights</option>
                      <option value="brakes-suspension">Brakes &amp; suspension</option>
                      <option value="maintenance-plan">Maintenance plan options</option>
                      <option value="other">Other mechanical work</option>
                    </select>
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-field">
                    <label htmlFor="quote-message">What do you need a quote for?</label>
                    <textarea
                      id="quote-message"
                      name="message"
                      rows="3"
                      placeholder="Tell us about the service or maintenance you need."
                    />
                  </div>
                </div>
                <button type="submit" className="btn btn-primary btn-full">
                  Submit quote request
                </button>
              </form>
            </div>
          </div>
        </section>

        <section className="section network" id="network">
          <div className="section-inner">
            <div className="section-header">
              <p className="eyebrow">Nationwide Coverage Model</p>
              <h2>How it works.</h2>
              <p>ServiCare operates through a KwaZulu-Natal hub and a nationwide referral network.</p>
            </div>

            <div className="network-grid">
              <div className="network-card">
                <h3>KwaZulu-Natal – Main Operations</h3>
                <p>Primary servicing and support hub.</p>
                <ul>
                  <li>Based in KwaZulu-Natal</li>
                  <li>Centralized support</li>
                </ul>
              </div>
              <div className="network-card">
                <h3>Nationwide Network</h3>
                <p>If we cannot service your vehicle directly, we refer you to a partnered workshop.</p>
                <ul>
                  <li>Compliant, vetted service providers</li>
                  <li>RMI-aligned workshops</li>
                </ul>
              </div>
              <div className="network-card">
                <h3>Industry Associations</h3>
                <p>Partner workshops meet compliance standards such as:</p>
                <ul>
                  <li>Retail Motor Industry Organisation (RMI)</li>
                  <li>National Automobile Dealers&apos; Association (NADA)</li>
                  <li>National Automobile Repairers and Maintenance Association (NARMA)</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section className="section trust" id="trust">
          <div className="section-inner">
            <div className="section-header">
              <p className="eyebrow">Trust &amp; Compliance</p>
              <h2>Why choose ServiCare.</h2>
              <p>Structured service and maintenance built on transparency and compliance.</p>
            </div>

            <div className="trust-grid">
              <div className="trust-card">
                <h3>Why choose ServiCare</h3>
                <ul>
                  <li>Nationwide workshop network</li>
                  <li>Professionally aligned suppliers</li>
                  <li>Transparent quotations</li>
                  <li>Detailed inspection reports</li>
                  <li>Centralized customer support</li>
                  <li>Structured maintenance protection</li>
                </ul>
              </div>
              <div className="trust-card trust-card-outline">
                <h3>How we protect you</h3>
                <ul>
                  <li>No unapproved repairs</li>
                  <li>Customer authorization before additional work</li>
                  <li>Full transparency on parts used</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section className="section contact" id="contact">
          <div className="section-inner">
            <div className="section-header">
              <p className="eyebrow">Location</p>
              <h2>Our main operations hub.</h2>
              <p>ServiCare Auto Center operates from our primary hub in KwaZulu-Natal.</p>
            </div>

            <div className="contact-inner">
              <div className="contact-column contact-column-location">
                <div className="contact-location-card">
                  <div className="contact-location-text">
                  <h3>Operations hub details</h3>
                  <p>
                    ServiCare Auto Center
                    <br />
                    13 Henwood Road
                    <br />
                    Pinetown, New Germany, 3600
                    <br />
                    South Africa
                  </p>
                  </div>
                  <div className="contact-location-meta">
                    <span className="location-pill">RMI‑aligned network</span>
                    <span className="location-pill">Central booking &amp; support</span>
                  </div>
                </div>
              </div>

              <div className="contact-column contact-column-map">
                <div className="map-placeholder">
                  <iframe
                    title="ServiCare Auto Center location"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3461.7625483657825!2d30.86317308998125!3d-29.81340365623498!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1ef6fe6bcef2cd23%3A0x33837bbb8d9f69e3!2s13%20Henwood%20Rd%2C%20Pinetown%2C%20New%20Germany%2C%203600%2C%20South%20Africa!5e0!3m2!1sen!2sus!4v1772799696858!5m2!1sen!2sus"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  />
                  <p className="map-caption">13 Henwood Road, Pinetown, New Germany, 3600, South Africa</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="section section--servi-banner">
          <div className="container">
            <div className="servi-banner">
              <div className="servi-banner__logo">
                <img src={ServiLogo2025} alt="Servi Contact logo" />
              </div>
              <p className="servi-banner__text">
                Ikusasalethu Group is a service owned by{' '}
                <a
                  href="https://www.servi-contact.co.za/"
                  target="_blank"
                  rel="noreferrer"
                  className="servi-banner__text-link"
                >
                  Servi Contact
                </a>
                .
              </p>
            </div>
          </div>
        </section>

      </main>

      <footer className="footer">
        <div className="footer-inner">
          <div className="footer-brand">
            <span className="footer-logo-mark">
              <img src={logo2025} alt="ServiCare Auto Center logo" className="footer-logo-image" />
            </span>
            <span className="footer-brand-text">ServiCare Auto Center</span>
          </div>
          <div className="footer-copy">
            <div className="footer-column">
              <h4>Contact</h4>
              <span>Office: 031 140 0041</span>
              <span>Business WhatsApp: 063 451 6104</span>
              <span>
                Email:{' '}
                <a href="mailto:info@servicare.co.za">
                  info@servicare.co.za
                </a>
              </span>
              <span>
                Support:{' '}
                <a href="mailto:support@servicare.co.za">
                  support@servicare.co.za
                </a>
              </span>
            </div>

            <div className="footer-column">
              <h4>About ServiCare</h4>
              <span>© {new Date().getFullYear()} ServiCare Auto Center. All rights reserved.</span>
              <span>Established in 2014.</span>
              <span>
                ServiCare Auto Center is a structured vehicle service network providing centralized support,
                nationwide access, and cost-controlled maintenance solutions.
              </span>
            </div>

            <div className="footer-column">
              <h4>Ownership</h4>
              <span>
                ServiCare Auto Center is a service owned by{' '}
                <a href="https://www.servi-contact.co.za" target="_blank" rel="noopener noreferrer">
                  Servi Contact
                </a>
                .
              </span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
